(function () {
  'use strict';

  angular
    .module('vcfinance.cart')
    .config(config);
  
  config.$inject = ['$stateProvider', '$logProvider'];
  
  function config($stateProvider, $log) {
    $stateProvider
      .state('playground.vcfinancecart', {
        url: '/financecart',
        views: {
          'playgroundmain@playground': {
            template: `
              <h3 class="alert alert-info"><tt>&lt;cartcounter clientid=""&gt;</tt></h3><div ui-view="cartcounterview"></div>
              <h3 class="alert alert-info"><tt>&lt;carteditor clientid=""&gt;</tt></h3><div ui-view="carteditview"></div>
            `
          }
        },
        onEnter: function ($log) {
          $log.debug('debug/routes - playground.financevccart entered');
        }
      });
    
    
    $stateProvider
      .state('playground.vcfinancecart.allcomponents', {
        url: '/allcomponents',
        resolve: {
          clientid: function () {
            return '571df9c97c01594fd0bbdf96';
          }
        },
        views: {
          // When `fooState.barState` is active, `fooComponent`
          // is loaded into the <ui-view name='content' />
          // which was created by `fooState`.
          // The component's `foo` input receives `fooData` resolve

          'carteditview@playground.vcfinancecart': {
            component: 'carteditor',
            bindings: {
              clientid: 'clientid',
              showtaxdetails: 'clientid'
            }
          },
          'cartcounterview@playground.vcfinancecart': {
            component: 'cartcounter',
            bindings: {
              clientid: 'clientid'
            }
          }
        },
        onEnter: function () {
          console.log('playground.vcfinancecart.allcomponents entered');
        }
      });
    
    
  }// all routes
  
  
}());






